"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatResult = void 0;
const data_type_1 = require("../../data/data-type");
const query_output_1 = require("./query-output");
/**
 * Data available as part of a Price Format query result.
 */
class PriceFormatResult extends query_output_1.QueryOutput {
}
exports.PriceFormatResult = PriceFormatResult;
/**
 * Specifies the custom symbol to be used as the symbol override for the currency.
 */
PriceFormatResult.SYMBOL = new PriceFormatResult('symbol', data_type_1.DataType.STRING);
/**
 * Specify whether a SPACE is required between the symbol and price in price format pattern.
 */
PriceFormatResult.INSERT_SPACE_IN_PATTERN = new PriceFormatResult('insert_space_in_pattern', data_type_1.DataType.BOOLEAN);
/**
 * Custom pattern to be used for formatting the price.
 */
PriceFormatResult.FORMAT_PATTERN = new PriceFormatResult('format_pattern', data_type_1.DataType.STRING);
/**
 * Override the currency symbol prefix.
 */
PriceFormatResult.SYMBOL_PREFIX = new PriceFormatResult('symbol_prefix', data_type_1.DataType.STRING);
/**
 * Override the currency symbol position
 */
PriceFormatResult.CURRENCY_SYMBOL_POSITION = new PriceFormatResult('currency_symbol_position', data_type_1.DataType.ENUM);
/**
 * Override the trailing zero display configuration.
 */
PriceFormatResult.TRAILING_ZERO_DISPLAY = new PriceFormatResult('trailing_zero_display', data_type_1.DataType.ENUM);
//# sourceMappingURL=price-format-result.js.map